import { useQuery } from "@tanstack/react-query";
import { getDocument } from "../services/document.service";
import { IDocument } from "../types/document.types";
import { getDocumentInfo } from "../utils/document.utils";
import * as React from "react";
import { debugLog } from "@/utils/debug";

export const WORD_DOCUMENT_INFO_QUERY_KEY = ["word-document-info"] as const;

/**
 * Shared Word-id query so every useDocument() caller enables GET /documents
 * from the same cache. Per-instance useState used to leave some panes with
 * msWordId=null forever, which disabled Discuss/Compass/Review APIs.
 */
export const useDocument = () => {
  const infoQuery = useQuery({
    queryKey: WORD_DOCUMENT_INFO_QUERY_KEY,
    queryFn: getDocumentInfo,
    staleTime: Infinity,
    retry: false,
  });
  const msWordId = infoQuery.data?.id;
  const hasWordId = msWordId != null && msWordId !== "";

  React.useEffect(() => {
    if (!hasWordId) return;
    debugLog("document", "Word custom-property id", { hasId: true });
  }, [hasWordId]);

  return useQuery<IDocument>({
    queryKey: ["document", msWordId],
    queryFn: () => getDocument(msWordId ?? ""),
    enabled: hasWordId,
    retry: false, // Don't retry on 404, we'll handle it manually
  });
};
